

function ShowList({ searchVal, list, chooseName }) {
    return (
        <div className="px-4 py-2 h92 overflow-auto">
            {
                list.filter(value => {
                    if (searchVal === "") {
                        return value
                    }
                    else if (value.name.toLowerCase().includes(searchVal.toLowerCase())) {
                        return value
                    }
                }).map((item, index) => {
                    return (
                        <div key={index} onClick={() => chooseName(item.name)}
                            className="text-right mb-1 flex flex-row-reverse items-center w-full"
                        >
                            <div className="w-10 h-9 rounded-full bg-slate-100"></div>
                            <p className="text-sm w-5/6 mr-4 py-2 border-b border-slate-200">{item.name}</p>
                        </div>
                    )
                })
            }
        </div>
    )
}
export default ShowList;